import { Injectable } from '@angular/core';
import { LandingModelService } from "./landingModel.service";
import { LandingModel } from "../model/landingModel";
import { HtmlUtilsService } from './html-utils.service';
import { UtilsService } from './utils.service';

declare var window: any;

@Injectable({
  providedIn: 'root'
})

export class GtmService {

  landingModel: LandingModel;

  constructor(private landingModelService: LandingModelService, private htmlUtilsService: HtmlUtilsService, private utilService: UtilsService) {
    this.landingModel = landingModelService.getLandingModel();
  }

  trackEventIfApplicable(actionType: string, category: string, action: string, label?: string) {
    if (this.landingModel.trackingGtm && !this.landingModel.isCachedVersion) {
      this.trackEvent(actionType, category, action, label)
    }
  }

  trackEvent(actionType: string, category: string, action: string, label?: string) {
    if (this.landingModel.isCachedVersion) return;

    this.ensureDataLayer("trackEvent");

    let gtmEvent: any = {
      'event': actionType,
      'eventCategory': category,
      'eventAction': action
    };

    if (typeof label === "string") {
      gtmEvent['eventLabel'] = label;
    }

    window.dataLayer.push(gtmEvent);
  }

  trackShoppingData(updateShifu: boolean = false) {
    this.trackData("trackShoppingData", "shopping_data_info", "shoppingDataReady", "shopping", updateShifu);
  }

  trackEccomerceData() {
    this.trackData("trackEccomerceData", "ecommerce_data_info", "ecommerceDataReady", "ecommerce");
  }

  // Solo se ejecuta cuando se cambia de producto en shifu (datalayer)
  private trackData(event: string, dataInfoKey: string, eventName: string, dataLayerKey: string, updateShifu?: boolean) {
    if (this.landingModel.isCachedVersion) return;
    
    this.ensureDataLayer(event);

    const landingModel = this.landingModelService.getLandingModel();
    const dataInfo = landingModel.trackers[dataInfoKey];

    if (!dataInfo || this.isEmptyObject(dataInfo)) {
      window.dataLayer.push({ [dataLayerKey]: undefined });
      return;
    }

    if (updateShifu) {
      window.dataLayer.push({ [dataLayerKey]: undefined });
      const dss = this.utilService.getCookieValue("dss")
      const dss2 = this.utilService.getCookieValue("dss2")
      dataInfo['is_package'] = window.upaData.pr === 'combinedproducts';
      dataInfo['product_type'] = this.resolveProductByName(window.upaData.pr);
      dataInfo['is_logged'] = !!dss || !!dss2;
    }

    window.dataLayer.push({
      event: eventName,
      [dataLayerKey]: dataInfo
    });
    // despacho evento personalizado para que dreck use trigger
    const customEvent = new CustomEvent(eventName, {});
    document.dispatchEvent(customEvent);
  }

  private ensureDataLayer(event: string) {
    if (window.dataLayer === undefined || typeof window.dataLayer !== "object") {
      this.htmlUtilsService.trackErrorToNR('dataLayer', `undefined in ${event}`);
      window.dataLayer = [];
    }
  }

  isEmptyObject(obj: any): boolean {
    return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
  }

  resolveProductByName(productName: string): string {
    switch (productName) {
      case 'flights':
        return 'FLIGHT';
      case 'hotels':
        return 'HOTEL';
      case 'combinedproducts':
        return 'COMBINED_PRODUCTS';
      case 'promotions':
        return 'PROMOTION';
      case 'vr':
        return 'VACATION_RENTAL';
      case 'activities':
        return 'ACTIVITY';
      case 'cars':
        return 'CAR';
      case 'insurance':
        return 'INSURANCE';
      case 'transfers':
        return 'TRANSFER';
      default:
        return 'NONE';
    }
  }
}
